




















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import appconst from '@/lib/appconst';
import Ajax from '@/lib/ajax';

interface SearchResultItem {
    productId: string;
    picName: string;
    score: number;
    country: string;
    imageUrl: string;
    productName: string;
    shopName: string;
    category: string;
    isExistsInDb: boolean;
    productUrl: string;
}

interface SearchForm {
    file: File | null;
    imageUrl: string;
    num: number;
    scoreThreshold: number;
}

@Component({
    name: 'ImageSearch'
})
export default class ImageSearch extends AbpBase {
    // 搜索表单
    searchForm: SearchForm = {
        file: null,
        imageUrl: '',
        num: 20,
        scoreThreshold: 0
    };
    searchRules = {};

    // Upload 相关
    headers: any = {};
    searchUrl: string = '';
    uploadData: any = {};
    fileList: any[] = [];
    loading: boolean = false;
    hasSearched: boolean = false;
    results: SearchResultItem[] = [];

    // ★★★ 搜索图片预览 ★★★
    searchImageUrl: string = '';
    searchImageSource: string = '';

    created() {
        this.headers = {
            "Authorization": "Bearer " + window.abp.auth.getToken(),
            ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
            "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
        };
        this.searchUrl = appconst.remoteServiceBaseUrl + 'api/services/app/ImageProduct/SearchByImage';
    }

    // 上传前校验
    beforeUpload(file: any) {
        var fileName = file.name.toLowerCase();
        var isValidType = fileName.endsWith('.jpg') ||
            fileName.endsWith('.jpeg') ||
            fileName.endsWith('.png') ||
            fileName.endsWith('.bmp') ||
            fileName.endsWith('.gif') ||
            fileName.endsWith('.webp');
        if (!isValidType) {
            this.$Message.error('请上传 JPG/JPEG/PNG/BMP/GIF/WEBP 格式的图片');
            return false;
        }
        var isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
            this.$Message.error('图片大小不能超过10MB');
            return false;
        }

        this.searchForm.file = file;
        this.searchForm.imageUrl = '';
        this.fileList = [{
            name: file.name,
            size: file.size,
            status: 'finished'
        }];

        // ★★★ 显示上传的图片预览 ★★★
        var reader = new FileReader();
        var _this = this;
        reader.onload = function (e: any) {
            _this.searchImageUrl = e.target.result;
            _this.searchImageSource = '本地文件：' + file.name;
        };
        reader.readAsDataURL(file);

        return false; // 阻止自动上传
    }

    // 移除文件
    handleRemove() {
        this.searchForm.file = null;
        this.fileList = [];
        // ★★★ 清除图片预览 ★★★
        this.searchImageUrl = '';
        this.searchImageSource = '';
    }

    // 搜索
    async handleSearch() {
        if (!this.searchForm.file && !this.searchForm.imageUrl) {
            this.$Message.warning('请上传图片或输入图片链接');
            return;
        }

        // ★★★ 如果是链接搜索，设置预览 ★★★
        if (this.searchForm.imageUrl && !this.searchForm.file) {
            this.searchImageUrl = this.searchForm.imageUrl;
            this.searchImageSource = '图片链接';
        }

        // 清空旧数据
        this.results = [];
        this.hasSearched = false;
        this.loading = true;

        try {
            var formData = new FormData();
            if (this.searchForm.file) {
                formData.append('file', this.searchForm.file);
            }
            if (this.searchForm.imageUrl) {
                formData.append('imageUrl', this.searchForm.imageUrl);
            }

            formData.append('num', this.searchForm.num.toString());
            formData.append('scoreThreshold', this.searchForm.scoreThreshold.toString());

            var response = await Ajax.post(this.searchUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            var result = response.data.result;
            this.loading = false;

            if (result && result.success) {
                this.results = result.results || [];
                this.hasSearched = true;
                if (this.results.length === 0) {
                    this.$Message.info('未找到相似图片');
                } else {
                    var msg = result.message || '搜索完成';
                    this.$Message.success(msg);
                }
            } else {
                var errorMsg = result && result.message ? result.message : '搜索失败';
                this.$Message.error(errorMsg);
                this.results = [];
                this.hasSearched = true;
            }
        } catch (error: any) {
            this.loading = false;
            var errorMsg: any = '搜索失败，请重试';
            if (error && error.error && error.error.message) {
                errorMsg = error.error.message;
            } else if (error && error.message) {
                errorMsg = error.message;
            }
            this.$Message.error(errorMsg);
            this.results = [];
            this.hasSearched = true;
        }
    }

    // 通过链接搜索
    handleSearchByUrl() {
        if (!this.searchForm.imageUrl) {
            this.$Message.warning('请输入图片链接');
            return;
        }
        this.searchForm.file = null;
        // 清空文件列表
        this.fileList = [];
        // ★★★ 设置链接预览 ★★★
        this.searchImageUrl = this.searchForm.imageUrl;
        this.searchImageSource = '图片链接';
        this.handleSearch();
    }

    // 重置
    handleReset() {
        this.searchForm.file = null;
        this.searchForm.imageUrl = '';
        this.searchForm.num = 20;
        this.searchForm.scoreThreshold = 0;
        this.fileList = [];
        this.results = [];
        this.hasSearched = false;
        this.loading = false;
        // ★★★ 清除图片预览 ★★★
        this.searchImageUrl = '';
        this.searchImageSource = '';
    }

    // 获取相似度颜色
    getScoreColor(score: number): string {
        if (score >= 0.8) {
            return '#19be6b';
        }
        if (score >= 0.6) {
            return '#ff9900';
        }
        return '#ed4014';
    }

    // 图片加载失败
    handleImageError(item: SearchResultItem) {
        item.imageUrl = '/images/no-image.png';
    }
}
